import React, { memo } from 'react'
import { useDrop } from 'react-dnd'
import { speech } from '../utils/utils'

const style = {
  height: '10rem',
  width: '100%',
  marginRight: '1rem',
  marginBottom: '1rem',
  color: 'white',
  textAlign: 'center',
  fontSize: '2rem',
  lineHeight: 'normal',
  float: 'left',
}
export const Dustbin = memo(function Dustbin({
  accept,
  lastDroppedItem,
  onDrop,
  tip,
}) {
  const [{ isOver, canDrop }, drop] = useDrop({
    accept,
    drop: onDrop,
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  })
  const isActive = isOver && canDrop
  let backgroundColor = '#222'

  if (tip) {
    if (isActive) {
      backgroundColor = 'darkgreen'
    } else if (canDrop) {
      backgroundColor = 'darkkhaki'
    }
  } else {
    backgroundColor = '#222'
  }

  function handleBinClick() {
    speech(accept[0])
  }

  return (
    <div
      ref={drop}
      role="Dustbin"
      style={{ ...style, backgroundColor }}
      onClick={handleBinClick}
    >
      {lastDroppedItem && (
        <p style={{ fontSize: '3rem' }}>{lastDroppedItem.name}</p>
      )}
    </div>
  )
})
